import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import './fonts.css';
import './index.css';

// Wait for Office.js to be ready before mounting (host must be Excel). We mount on error too,
// so the app can render a clear "open me inside Excel" message rather than a blank page.
const mount = () => {
  const container = document.getElementById('container');
  if (!container) throw new Error('Root #container not found');
  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

if (typeof Office !== 'undefined') {
  Office.onReady().then(mount).catch(mount);
} else {
  mount();
}
